import React from 'react';
import { GenericSearchListForm } from '../forms/GenericSearchListForm';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { SonForm } from '../../../_lib/Form2';

export function GenericSearchListEdit({ form }: { form: SonForm<any> }) {
  return <GenericSearchListForm form={form} />;
}

export const GenericSearchListEditView = asFetchableView(GenericSearchListEdit);
